"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFileUploadAction = void 0;
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var useFileUploadAction = exports.useFileUploadAction = function useFileUploadAction() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    startFileUpload = _useCommonPageActions.startFileUpload,
    endFileUpload = _useCommonPageActions.endFileUpload;

  /**
   * This function is used to start the File Upload Action.
   * * @param {Object} props - The properties for file Upload Action.
   * @param {string} props.title - The name of the file.
   * @param {string} props.fileType - The type of the file.
   * @param {string} props.extension - The file extension.
   * @param {boolean} props.isDragAndDrop - Indicates if the file was uploaded via drag and drop.
   * @param {boolean} props.isMultiFileUpload - Indicates if multiple files were uploaded.
   * @param {string} props.externalVideoId - The external video ID.
   * @param {number} props.fileSizeInBytes - The size of the file in bytes.
   * @returns {void}
   */
  var startFileUploadAction = function startFileUploadAction(props) {
    startFileUpload({
      title: props.title,
      fileType: props.fileType,
      extension: props.extension,
      isDragAndDrop: props.isDragAndDrop,
      isMultiFileUpload: props.isMultiFileUpload,
      externalVideoId: props.externalVideoId,
      fileSizeInBytes: props.fileSizeInBytes
    });
  };

  /**
   * This function is used to end the File Upload Action.
   * * @param {Object} props - The properties for file Upload Action.
   * @param {string} props.title - The name of the file.
   * @param {string} props.fileType - The type of the file.
   * @param {string} props.extension - The file extension.
   * @param {boolean} props.isDragAndDrop - Indicates if the file was uploaded via drag and drop.
   * @param {boolean} props.isMultiFileUpload - Indicates if multiple files were uploaded.
   * @param {string} props.externalVideoId - The external video ID.
   * @param {number} props.fileSizeInBytes - The size of the file in bytes.
   * @param {string} props.errorMessage - The error message if the upload failed.
   * @returns {void}
   */
  var endFileUploadAction = function endFileUploadAction(props) {
    endFileUpload({
      title: props.title,
      fileType: props.fileType,
      extension: props.extension,
      isDragAndDrop: props.isDragAndDrop,
      isMultiFileUpload: props.isMultiFileUpload,
      externalVideoId: props.externalVideoId,
      fileSizeInBytes: props.fileSizeInBytes,
      error: props.errorMessage ? "File upload failed: ".concat(props.errorMessage) : null
    });
  };
  return {
    startFileUploadAction: startFileUploadAction,
    endFileUploadAction: endFileUploadAction
  };
};